import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { ValidatedLegacyDateSetting, getDateSettingDetails } from '@bingads-webui-campaign/date-setting';

import { PANEL_KEYS } from './panel-keys';
import { StartEndDateImg } from '../../media';
import { DateSettingsShimmer, withShimmer } from '../shimmers';

const ValidatedLegacyDateSettingWithShimmer = withShimmer(ValidatedLegacyDateSetting, DateSettingsShimmer);

export const DateSettingsPanel = (props) => {
  const i18n = useContext(I18nContext);

  const {
    isLoading,
    expand,
    timeZone,
    data = {},
    ...rest
  } = props;

  const {
    StartDate,
    EndDate,
    Id,
  } = data;

  return (
    <ValidatedPanel
      key={PANEL_KEYS.START_END_DATES}
      title={<TextTitle
        titleKey={_TL_('Start and end dates')}
        details={getDateSettingDetails(i18n, StartDate, EndDate)}
        icon={StartEndDateImg}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
          expand,
          expandKey: PANEL_KEYS.START_END_DATES,
        }}
      {...rest}
    >
      <ValidatedLegacyDateSettingWithShimmer
        showShimmer={isLoading}
        i18n={i18n}
        validationProps={{
          data: {
            StartDate,
            EndDate,
            TimeZone: timeZone,
            isCreate: !Id,
          },
          initialValue: {
            StartDate: StartDate || new Date(),
            EndDate: (_.isNull(EndDate) || _.isUndefined(EndDate)) ? null : EndDate,
          },
        }}
      />
    </ValidatedPanel>
  );
};

DateSettingsPanel.propTypes = {
  isLoading: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  collapseState: PropTypes.arrayOf(PropTypes.any).isRequired,
  expand: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  timeZone: PropTypes.string,
};

DateSettingsPanel.defaultProps = {
  isLoading: false,
  data: {},
  timeZone: null,
};
